"use strict";

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var Graphics = require("../../graphics");

var solver_1 = require("../../solver");

var Specification = require("../../specification");

var axis_1 = require("./axis");

var plot_segment_1 = require("./plot_segment");

var LineGuide =
/*#__PURE__*/
function (_plot_segment_1$PlotS) {
  _inherits(LineGuide, _plot_segment_1$PlotS);

  function LineGuide() {
    var _this;

    _classCallCheck(this, LineGuide);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LineGuide).apply(this, arguments));
    _this.attributeNames = ["x1", "x2", "y1", "y2"];
    _this.attributes = {
      x1: {
        name: "x1",
        type: Specification.AttributeType.Number
      },
      y1: {
        name: "y1",
        type: Specification.AttributeType.Number
      },
      x2: {
        name: "x2",
        type: Specification.AttributeType.Number
      },
      y2: {
        name: "y2",
        type: Specification.AttributeType.Number
      }
    };
    return _this;
  }

  _createClass(LineGuide, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x1 = -100;
      attrs.x2 = 100;
      attrs.y1 = -100;
      attrs.y2 = 100;
    }
  }, {
    key: "buildGlyphConstraints",
    value: function buildGlyphConstraints(solver) {
      var chart = this.parent.object;
      var props = this.object.properties;
      var rows = this.parent.dataflow.getTable(this.object.table);

      var _solver$attrs = solver.attrs(this.state.attributes, ["x1", "y1", "x2", "y2"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 4),
          x1 = _solver$attrs2[0],
          y1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2],
          y2 = _solver$attrs2[3];

      var attrs = this.state.attributes;
      var count = this.state.dataRowIndices.length;
      var dataIndices = this.state.dataRowIndices;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.state.glyphs.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var index = _ref2[0];
          var markState = _ref2[1];
          var t = (0.5 + index) / count;

          if (props.axis == null) {
            t = (0.5 + index) / count;
          } else {
            var data = props.axis;

            switch (data.type) {
              case "numerical":
                {
                  var row = rows.getGroupedContext(dataIndices[index]);
                  var expr = this.parent.dataflow.cache.parse(data.expression);
                  var value = expr.getNumberValue(row);
                  t = (value - data.domainMin) / (data.domainMax - data.domainMin);
                }
                break;

              case "categorical":
                {
                  var axis = axis_1.getCategoricalAxis(props.axis, false, false);

                  var _row = rows.getGroupedContext(dataIndices[index]);

                  var _expr = this.parent.dataflow.cache.parse(data.expression);

                  var _value = _expr.getStringValue(_row);

                  var i = data.categories.indexOf(_value);
                  t = (axis.ranges[i][0] + axis.ranges[i][1]) / 2;
                }
                break;

              case "default":
                {
                  t = (0.5 + index) / count;
                }
                break;
            }
          }

          solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[t, x2], [1 - t, x1]], [[1, solver.attr(markState.attributes, "x")]]);
          solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[t, y2], [1 - t, y1]], [[1, solver.attr(markState.attributes, "y")]]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "getDropZones",
    value: function getDropZones() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var zones = [];
      zones.push({
        type: "line",
        p1: {
          x: x1,
          y: y1
        },
        p2: {
          x: x2,
          y: y2
        },
        title: "Axis",
        dropAction: {
          axisInference: {
            property: "axis"
          }
        }
      });
      return zones;
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "point",
        x: x1,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x2,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }];
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          x2 = attrs.x2,
          y1 = attrs.y1,
          y2 = attrs.y2;
      return {
        type: "line",
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      };
    }
  }, {
    key: "getGraphics",
    value: function getGraphics() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var props = this.object.properties;
      var length = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));

      if (props.axis == null) {
        return Graphics.makeLine(x1, y1, x2, y2, {
          strokeColor: {
            r: 0,
            g: 0,
            b: 0
          },
          fillColor: null
        });
      }

      if (props.axis && props.axis.visible) {
        var renderer = new axis_1.AxisRenderer();
        renderer.setAxisDataBinding(props.axis, 0, length, false, false);
        var g = renderer.renderLine(x1, y1, Math.atan2(y2 - y1, x2 - x1) / Math.PI * 180, 1);
        return g;
      }
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(LineGuide.prototype), "getAttributePanelWidgets", this).call(this, manager)), _toConsumableArray(axis_1.buildAxisWidgets(props.axis, "axis", manager, "Axis")));
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      var r = [];

      if (this.object.properties.axis) {
        var axis = this.object.properties.axis;
        r.push(axis_1.buildAxisInference(this.object, "axis"));
      }

      return {
        inferences: r
      };
    }
  }]);

  return LineGuide;
}(plot_segment_1.PlotSegmentClass);

LineGuide.classID = "plot-segment.line";
LineGuide.type = "plot-segment";
LineGuide.metadata = {
  displayName: "PlotSegment",
  iconPath: "plot-segment/line",
  creatingInteraction: {
    type: "line-segment",
    mapping: {
      x1: "x1",
      y1: "y1",
      x2: "x2",
      y2: "y2"
    }
  }
};
LineGuide.defaultProperties = {
  visible: true
};
exports.LineGuide = LineGuide;